import styled from 'styled-components';
import { deviceBreakpoints, variables } from 'variables';

export const Step1SC = styled.div`
  background: ${(props) => props.theme.pageBackgroundColor};
  padding: ${variables.pageContentPadding}px;
  width: 100%;
  padding-bottom: 60px;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    padding-top: 0;
  }
`;

export const Step2SC = styled.div`
  background: white;
  padding: 60px ${variables.pageContentPadding}px;
  width: 100%;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    padding: 0 ${variables.pageContentPadding}px;
  }
`;

export const FireWallSC = styled.div`
  margin-top: 20px;
`;

export const ListContainer = styled.div`
  padding: 10px 0;
`;

export const SingleList = styled.div`
  pointer-events: ${(props) => (props.loading ? 'none' : 'auto')};
  opacity: ${(props) => (props.loading ? '0.5' : '1')};
  background: white;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  margin-top: 15px;
  &:hover {
    background-color: #f9f9f9;
  }
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px 15px 10px;
  @media (max-width: 960px) {
    flex-wrap: wrap;
    padding: 0;
  }
  h5 {
    margin: 0;
    font-weight: 400;
  }
`;

export const FirstContent = styled.div`
  display: flex;
  width: 60%;
  padding-right: 1em;
  @media (max-width: 960px) {
    width: 100%;
    padding: 15px 20px 10px 20px;
    border-bottom: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  }
  .circle {
    font-size: 8px;
    margin-top: 7px;
    color: ${(props) => props.theme.primaryDarkColor};
    margin-right: 10px;
  }

  .pencil {
    font-size: 16px;
    margin-top: 2px;
    color: ${(props) => props.theme.primaryDarkColor};
    margin-left: 10px;
    cursor: pointer;
  }
`;

export const SecondContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 40%;
  padding-left: 1em;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: space-between;
    padding: 10px 20px;
  }
  @media (max-width: 500px) {
    flex-wrap: wrap;
    gap: 10px;
  }
`;

export const StatusConteiner = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionConteiner = styled.div`
  display: flex;
  align-items: center;
  margin-left: 2em;
  i {
    margin-right: 1em;
    cursor: pointer;
    color: ${(props) => props.theme.primaryDarkColor};
  }
  @media (max-width: 500px) {
    justify-content: flex-end;
    width: 100%;
  }
`;

export const BlueContainer = styled.div`
  border-radius: 5px;
  margin-right: 2em;
  color: white;
  padding: 5px 1em;
  background: #008dc3;
  p {
    white-space: nowrap;
  }
`;

export const GreenContainer = styled.div`
  border-radius: 5px;
  margin-right: 1em;
  color: white;
  padding: 5px 1em;
  background: ${(props) => props.theme.serverSizeCard.tag.backgroundColor};
  p {
    white-space: nowrap;
  }
`;

export const SettingPanel = styled.div`
  background: ${(props) => props.theme.panelBackground};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;
